export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10130.afa0eff1.jpg";